// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyLoadEarlyCatalogItemsRequest: (page: string) => any = (_: string) => {
  return import('./early-load-catalog-items-request').then((m) => () => {
    m.earlyLoad();
  });
};
